import React, { useContext, useState } from "react";
import { Form, Input, message } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { getFilter, loginuser } from "../utils/API";
import { getErrorMessage } from "../utils/getErrorMessage";
import { AuthContext } from "./AuthContext";
import { useSettings } from "../Pages/Settings/SettingContext";

const Login: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { settings, updateSettings } = useSettings();
  const { setAuthData } = useContext(AuthContext);
  const Logo_Main = require("../Assets/logo.png");
  const navigate = useNavigate();



  const onFinish = async (values: any) => {
    setIsLoading(true);
    try {
      const res: any = await loginuser(values);
      
      if (!res || !res.user) {
        throw new Error("Invalid response from server");
      }

      message.success("Login successful!");

      const authData = {
        token: res.token,
        user: res.user,
        roleId: res.user?.roleId || null,
        permissions: res.permissions || [],
      };

      localStorage.setItem("token", res.token);
      localStorage.setItem("authData", JSON.stringify(authData));
      setAuthData(authData);
      setIsLoading(false);

      if (values.employeeId == "E108" || values.employeeId == "E114" || values.employeeId == "E102" || values.employeeId == "E105" || values.employeeId == "E107") {
        navigate("/attendance");
      } else {
        navigate("/dashboard");
      }
    } catch (error: any) {
      setIsLoading(false);
      // console.error("Login error:", error); // Log the full error for debugging
      message.error(getErrorMessage(error) || "Login failed");
    }
  };



  return (
    <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-2xl border border-blue-500 rounded-lg">
        <div style={{ display: "flex", justifyContent: "center", margin: "25px", }}>
          <img
            src={settings ? settings.logo : Logo_Main}
            alt="logo"
            style={{ maxHeight: "50px" }}
          />
        </div>
        <div className="sm:mx-auto sm:w-full sm:max-w-xl">
          <Form initialValues={{ remember: true }} onFinish={onFinish} className="m-4">
            <label className="font-bold m-2">EmployeeId</label>
            <Form.Item name="employeeId" rules={[{ required: true, message: "Please enter your Id!" }]}>
              <Input placeholder="Enter Id" className="antInputClass rounded" />
            </Form.Item>

            <label className="font-bold m-2">Password</label>
            <Form.Item name="password" rules={[{ required: true, message: "Please enter your password!" }]}>
              <Input.Password placeholder="Enter Password" className="antInputClass rounded p-2" />
            </Form.Item>

            <Form.Item>
              <button type="submit" disabled={isLoading} className="w-full p-3 rounded-md bg-[#001529] text-white">
                {isLoading ? "Signing in..." : "Sign in"}
              </button>
            </Form.Item>

            <div className="text-center">
              <span className="text-gray-600">Don't have an account? </span>
              <Link to="/register" className="text-blue-500 hover:underline">Register here</Link>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default Login;
